import { useTranslation } from "react-i18next";

export const PTTranslate = ({ tk }) => {
  const { t } = useTranslation();
  if(typeof tk != "string") 
    return <>{tk}</>;
  return <>{t(tk)}</>;
};

export default PTTranslate;
